import layout from "~/layout/App/Index.vue";
import auth from "../middleware/auth";

const referralRoutes = {
  path: "/referral",
  component: layout,
  name: "referral",
  meta: {
    breadcrumb: [{ name: 'referral_program', route: "referral.program.index" }],
    middleware: auth
  },
  children: [
    {
      path: "",
      component: () => import("~/views/Referral/Program"),
      name: "referral.program.index",
      meta: {
        middleware: auth,
        breadcrumb: [{ name: "breadcrumb.overview" }],
      }
    },
    {
      path: "program",
      component: () => import("~/views/Referral/Program"),
      name: "referral.program.index",
      meta: {
        middleware: auth,
        breadcrumb: [{ name: "breadcrumb.overview" }],
      }
    },
    {
      path: "withdrawals",
      component: () => import("~/views/Referral/Withdrawals"),
      name: "referral.withdrawals",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'referral_program', route: "referral.program.index" },
          { name: "referral.withdrawal.title" }
        ],
      }
    },
    {
      path: "counterparties",
      component: () => import("~/views/Referral/Counterparties.vue"),
      name: "referral.counterparties",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'referral_program', route: "referral.program.index" },
          { name: "counterparties" }
        ],
      }
    },
    {
      path: "users",
      component: () => import("~/views/Referral/Users"),
      name: "referral.users",
      meta: {
        middleware: auth,
        breadcrumb: [
          { name: 'referral_program', route: "referral.program.index" },
          { name: "users" }
        ],
      }
    }
  ]
};

export default referralRoutes;
